<template>
  <v-badge
    :content="cartItemCount"
    :value="cartItemCount > 0"
    color="primary"
    overlap
    offset-x="20"
    offset-y="20"
  >
    <v-btn icon @click="$emit('click')">
      <v-icon>mdi-cart-outline</v-icon>
    </v-btn>
  </v-badge>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CartIcon',
  
  computed: {
    ...mapGetters('cart', ['cartItemCount'])
  }
}
</script>

<style scoped>
/* Badge personalizado con el color primary de NFCero */
::v-deep .v-badge__badge {
  font-weight: 700;
  font-size: 0.75rem;
}
</style>
